<template>
  <div>
    Reports
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>